<template>
    <apexchart type="area" :options="chartOptions" :series="series"></apexchart>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';

export default{
    name: 'chartcontainer',
    components: {
        apexchart: VueApexCharts,
    },

    props:{
        //[ { "name": "", data: [[x0, y0], ...]}, ... ]
        series: Array,
    },
    data(){
        return {
            tooltip: {
                enabled: true,
                style: {
                    fontSize: '12px',
                    fontFamily: undefined
                },
                onDatasetHover: {
                    highlightDataSeries: false,
                },
                x: {
                    show: true,
                    format: 'dd MMM hh:mm:ss',
                    formatter: undefined,
                },
            },
          
            chartOptions: {

                chart: {
                    height:'100%',
                    animations: {
                        enabled: false,
                    },
                    id: 'area-datetime',
                    type: 'line',
                    zoom: {
                        autoScaleYaxis: true
                    }
                },
                dataLabels: {
                    enabled: false
                },
                markers: {
                    size: 3,
                    style: 'hollow',
                },
                xaxis: {
                    type: 'datetime',
                    labels:{
                        datetimeUTC:false
                    }
                },
                yaxis:{
                    labels:{
                        formatter: (value) => { return value.toFixed(3) }
                    }
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 1,
                        inverseColors: false,
                        opacityFrom: 0.5,
                        opacityTo: 0,
                        stops: [0, 90, 100]
                    }
                },
                tooltip: {
                    x: {
                        format: 'dd MMM yyyy , HH:mm:ss'
                    }
                },
            },
          
            selection: 'one_year',

        }
    },
}
</script>
    